import { render, staticRenderFns } from "./SizePicker.vue?vue&type=template&id=996fd7de&scoped=true&"
import script from "./SizePicker.vue?vue&type=script&lang=js&"
export * from "./SizePicker.vue?vue&type=script&lang=js&"
import style0 from "./SizePicker.vue?vue&type=style&index=0&id=996fd7de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996fd7de",
  null
  
)

export default component.exports